import React, { useEffect, useReducer } from "react";
import { useAppContext } from "../app/AppContext";
import PropTypes from 'prop-types';
import initialState from './initialState';
import reducer from './reducer';

import {
  actionActivityFetchAll,
  actionActivityGoalFetchAll,
} from '../torga/Activity/actions';
import {
  actionActivityEquipmentFetchAll,
  actionEquipmentFetchAll,
} from './Equipment/actions';

import {
  actionFetchRoutines,
  actionRoutineFetchActivities,
} from './Routine/actions';

import { actionGoalFetchAll, actionGoalTaskFetchAll } from './Goal/actions';
import { actionTaskFetchAll } from './Task/actions';

export const TorgaContext = React.createContext();

export const useTorgaContext = () => React.useContext(TorgaContext);

export const TorgaContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { dispatch: appDispatch } = useAppContext();
  const { refreshKey, errors } = state;

  useEffect(() => {
    if (errors.length)
      appDispatch({
        type: 'ERROR_UP',
        payload: errors,
      });
  }, [errors]);

  useEffect(() => {
    dispatchAction(actionActivityFetchAll());
    dispatchAction(actionEquipmentFetchAll());
    dispatchAction(actionActivityEquipmentFetchAll());
    dispatchAction(actionFetchRoutines());
    dispatchAction(actionRoutineFetchActivities());
    dispatchAction(actionGoalFetchAll());
    dispatchAction(actionTaskFetchAll());
    dispatchAction(actionGoalTaskFetchAll());
    dispatchAction(actionActivityGoalFetchAll());
  }, [refreshKey]);

  async function dispatchAction(action, completeCallback) {
    try {
      await action(dispatch, completeCallback);
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err });
    }
  }

  return (
    <TorgaContext.Provider value={{ state, dispatch, dispatchAction }}>
      {props.children}
    </TorgaContext.Provider>
  );
};

TorgaContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};